function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("link", {
  type: "text/css",
  rel: "stylesheet",
  id: "dark-mode-custom-link"
});

var _ref3 = /*#__PURE__*/React.createElement("link", {
  type: "text/css",
  rel: "stylesheet",
  id: "dark-mode-general-link"
});

var _ref4 = /*#__PURE__*/React.createElement("style", {
  lang: "en",
  type: "text/css",
  id: "dark-mode-custom-style"
});

var _ref5 = /*#__PURE__*/React.createElement("style", {
  lang: "en",
  type: "text/css",
  id: "dark-mode-native-style"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref18 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref19 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref20 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var SvgHomeInactive = function SvgHomeInactive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, _ref2, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.462,81.079H8.538C3.825,81.079,0,84.904,0,89.616v299.128c0,4.713,3.825,8.538,8.538,8.538H76.84v25.101    c0,4.713,3.825,8.538,8.538,8.538h341.51c4.713,0,8.538-3.825,8.538-8.538v-25.101h68.037c4.713,0,8.538-3.825,8.538-8.538V89.616    C512,84.904,508.175,81.079,503.462,81.079z M482.886,98.154l-16.469,16.666H46.198L29.327,98.154H482.886z M426.887,294.112    h-93.915c-1.921,0-3.611,0.751-5.037,1.827c0.06-2.732-1.033-5.439-3.407-7.146l-23.701-16.973c-1.87-1.34-4.201-1.878-6.463-1.46    c-2.263,0.401-4.269,1.699-5.567,3.594l-39.718,58.347c-2.613,3.833-1.682,9.041,2.083,11.739l2.092,1.494H51.226v-213.64h409.812    v213.649h-25.613V302.65C435.425,297.937,431.6,294.112,426.887,294.112z M418.349,311.188v34.356h-76.84v-34.356H418.349z     M324.434,303.735v41.809h-28.465L324.434,303.735z M277.69,342.052l-9.81-7.027l30.113-44.234l9.81,7.027L277.69,342.052z     M17.076,110.056l17.076,16.871v223.45l-17.076,17.28V110.056z M418.349,413.846H93.915v-16.563h324.434V413.846z     M426.887,380.207H85.377H28.678l17.374-17.588h286.919h93.915h38.975l17.801,17.588H426.887z M494.924,367.324l-16.811-16.606    V127.276l16.811-17.016V367.324z",
    fill: "#afafaf",
    "data-original": "#000000",
    style: {},
    className: ""
  }))), _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeInactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home-inactive.14d28f51.svg";
export { ForwardRef as ReactComponent };